/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductSearchDetailsFilter } from '../../models/product-search-details-filter';

export interface GetBrandsForSearchResult$Params {

/**
 * Determines which logic will be used BUYING/SELLING
 */
  marketplaceSection: 'BUYING' | 'SELLING';
      body: ProductSearchDetailsFilter
}

export function getBrandsForSearchResult(http: HttpClient, rootUrl: string, params: GetBrandsForSearchResult$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
  const rb = new RequestBuilder(rootUrl, getBrandsForSearchResult.PATH, 'post');
  if (params) {
    rb.query('marketplaceSection', params.marketplaceSection, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<string>>;
    })
  );
}

getBrandsForSearchResult.PATH = '/search/products/brands';
